/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Top_Up_AmountInputs */

const cs_billing_top_up_amount = /** @type {(inputs: Billing_Top_Up_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredity`)
};

const en_billing_top_up_amount = /** @type {(inputs: Billing_Top_Up_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Billing_Top_Up_AmountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_top_up_amount = /** @type {((inputs?: Billing_Top_Up_AmountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Top_Up_AmountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_top_up_amount(inputs)
	return cs_billing_top_up_amount(inputs)
});